import type { ParsedData, Curve } from '../../interfaces/toolData';
import { cleanTimeSeriesData } from '../dataQuality/timeSeriesCleanup';

/**
 * Centralized data quality service for all parsed data
 * Applies consistent quality checks across all tool types and parsers
 */
export class DataQualityService {
  /**
   * Apply quality checks to parsed data
   * This is the main entry point called from ParserFactory after parsing
   */
  static clean(parsedData: ParsedData): ParsedData {
    // Only process data that has curves
    if (!parsedData.curves || parsedData.curves.length === 0) {
      return parsedData;
    }

    // Apply quality cleaning to each curve
    const cleanedCurves: Curve[] = [];
    let totalRemovedPoints = 0;
    
    for (const curve of parsedData.curves) {
      const cleanupResult = cleanTimeSeriesData(curve);
      cleanedCurves.push(cleanupResult.cleanedCurve);
      totalRemovedPoints += cleanupResult.cleanupSummary.removedCount;
    }

    // Log summary if outliers were found
    if (totalRemovedPoints > 0) {
      console.log(`🧹 Data quality: removed ${totalRemovedPoints} outlier/invalid points across ${cleanedCurves.length} curves`);
    }

    // Return cleaned data with same structure
    return {
      ...parsedData,
      curves: cleanedCurves
    };
  }
}